// Continue shopping link redirect to collections/all
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const continueShoppingLinks = document.querySelectorAll('.c-continue-shopping-link');

    continueShoppingLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const collectionsUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'collections/all') || '/collections/all';
        window.location.href = collectionsUrl;
      });
    });
  });
})();

